var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['o-home-landing', (_vm.$license.shouldUpgrade && _vm.$store.getters.getAcademyShowHeaderMessage) ||
  _vm.$store.getters.getAcademyData.persona === undefined
    ? 'o-home-landing-upgrade' : '']},[_c('MoleculeHomeLandingAccess')],1)}
var staticRenderFns = []

export { render, staticRenderFns }